import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManagerPackagesSubscriptionsPage } from './manager-packages-subscriptions.page';

const routes: Routes = [
  {
    path: '',
    component: ManagerPackagesSubscriptionsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManagerPackagesSubscriptionsPageRoutingModule {}
